import { Link } from 'react-router-dom';
// import Button from '../../atoms/button/button.atom';
import { Button } from 'antd';import { HeaderImageContainer } from './header-image.styles';

const HeaderImage = ({img, title, subtitle, buttonText }) => {
    return (
        <HeaderImageContainer style={{
            backgroundImage: `url(${img})`,
        }}>
            <span className="header-info">
                <h1>{title}</h1>
                <p>{subtitle}</p>
                <Link to={"/company/contactus"} 
                    style={{ 
                        color: 'inherit',
                        textDecoration: 'inherit',
                        width: '40%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                }} >
                    <Button type='primary' className='button'>{buttonText}</Button>
                </Link>
            </span>

        </HeaderImageContainer>
    )
}

export default HeaderImage;